"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import classNames from "classnames";
import { throttle } from "lodash";
import { observable, runInAction } from "mobx";
import { observer } from "mobx-react";
import React from "react";
import { randomString } from "../../../utils";
import Tooltip, { TooltipPosition } from "../Tooltip/Tooltip";
export var ToggleTheme = /* @__PURE__ */ ((ToggleTheme2) => {
  ToggleTheme2["Light"] = "light";
  ToggleTheme2["Dark"] = "dark";
  return ToggleTheme2;
})(ToggleTheme || {});
let Toggle = class extends React.Component {
  constructor(props) {
    super(props);
    this.disabledMessage = "placeholder";
    this.toggleId = `toggle-${randomString()}`;
    this.labelId = `toggle-label-${randomString()}`;
    this.toggleValue = () => {
      if (this.props.disabled) {
        return;
      }
      if (this.props.onChange) {
        this.props.onChange(!this.props.value);
      }
    };
    this.changeState = throttle(this.toggleValue, 200, { leading: true, trailing: false });
    this.disabledMessage = "";
    if (props.getDisabledMessage) {
      props.getDisabledMessage().then((result) => {
        runInAction(() => this.disabledMessage = result);
      });
    }
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: `toggle-button toggle-button--${this.props.theme}` }, /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames([
          "toggle-button__click-field",
          { "toggle-button__click-field--is-disabled": this.props.disabled }
        ])
      },
      this.renderLabel(),
      !!this.disabledMessage && this.props.disabled ? /* @__PURE__ */ React.createElement(
        Tooltip,
        {
          content: this.disabledMessage,
          show: this.disabledMessage ? void 0 : false,
          position: TooltipPosition.Bottom
        },
        this.renderPill()
      ) : this.renderPill()
    ));
  }
  renderLabel() {
    const toggleLabelClasses = classNames([
      "toggle-button__label",
      {
        "toggle-button__label--disabled": this.props.disabled,
        "toggle-button__label--hidden": this.props.labelHidden
      }
    ]);
    return /* @__PURE__ */ React.createElement("label", { htmlFor: this.toggleId, className: toggleLabelClasses, id: this.labelId }, this.props.label);
  }
  renderPill() {
    const togglePillClasses = classNames([
      "toggle-button__mount",
      {
        "toggle-button__mount--is-toggled": this.props.value,
        "toggle-button__mount--is-disabled": this.props.disabled
      }
    ]);
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: togglePillClasses,
        role: "switch",
        id: this.toggleId,
        "aria-disabled": this.props.disabled,
        "aria-checked": this.props.value,
        "aria-labelledby": this.labelId,
        tabIndex: this.props.disabled ? -1 : 0,
        onClick: this.changeState
      },
      /* @__PURE__ */ React.createElement("div", { className: "toggle-button__switch" })
    );
  }
};
Toggle.defaultProps = {
  theme: "light" /* Light */
};
__decorateClass([
  observable.ref
], Toggle.prototype, "disabledMessage", 2);
Toggle = __decorateClass([
  observer
], Toggle);
export {
  Toggle as default
};
